import { Tabs, TabsContent, TabsList, TabsTrigger } from '@design-system';
import { useSearchParams } from 'react-router-dom';
import { Conversations, EmailTest, ReplyLibrary } from '@/features/wizard-magic-email';

/**
 * Magic Email for staff: the replies the assistant may send (find, edit, publish) and every
 * conversation it has had (what was sent, the AI's private draft, the per-conversation switch).
 * `?tab=library|conversations|test`.
 */
export function WizardMagicEmailPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') ?? 'library';

  return (
    <main className="min-h-full bg-[#F7F7F8] px-4 pt-8 pb-12 sm:px-6 lg:px-10">
      <Tabs
        value={tab}
        onValueChange={value => setSearchParams({ tab: value }, { replace: true })}
        className="mx-auto flex max-w-[1320px] flex-col gap-6"
      >
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="flex flex-col gap-1.5">
            <h1 className="text-[28px] font-bold tracking-[-0.01em]">Magic Email</h1>
            <p className="text-[15px] text-zinc-600">The replies the assistant may send, and every conversation it has had.</p>
          </div>
          <TabsList>
            <TabsTrigger value="library">Replies</TabsTrigger>
            <TabsTrigger value="conversations">Conversations</TabsTrigger>
            <TabsTrigger value="test">Test</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="library">
          <ReplyLibrary />
        </TabsContent>
        <TabsContent value="conversations">
          <Conversations />
        </TabsContent>
        <TabsContent value="test">
          <EmailTest />
        </TabsContent>
      </Tabs>
    </main>
  );
}
